// ParticipantApp.jsx
import { useState } from 'react';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import MainContent from './components/MainContent';

export default function ParticipantApp() {
  const [activeTab, setActiveTab] = useState('overview');

  return (
    <div className="layout">
      <Header />
      <div className="main">
        <Sidebar onSelect={setActiveTab} activeTab={activeTab} />
        <MainContent selectedTab={activeTab} />
      </div>
    </div>
  );
}
